<template>
  <div class="Fuell-Table--row">
    <div
      class="Fuell-Table--item clickable"
      @click="editMileageCategory"
    >{{ categoryName }}</div>
    <div
      class="Fuell-Table--item clickable"
      @click="editMileageCategory"
    >
      <span class="ellipsis">{{ categoryRate }}</span>
    </div>
    <div class="Fuell-Table--item Fuell-Table--options">
      <dropdown :closeOnClickInside="false">
        <div
          class="clickable"
          role="button"
          @click="editMileageCategory"
        >{{$t('ACTION_EDIT')}}</div>
        <div
          class="clickable"
          role="button"
          @click="handleDeleteMileageCategory"
        >{{$t('ACTION_REMOVE')}}</div>
      </dropdown>
    </div>
    <confirm-modal
      v-if="showConfirmModal"
      :open.sync="showConfirmModal"
      @accept="deleteMileageCategory"
      :title="'ACTION_REMOVE'"
      :acceptText="'ACTION_REMOVE'"
    ></confirm-modal>
  </div>
</template>

<script>
import Dropdown from '@/components/Commons/Dropdown'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'MileageCategoryTableRosw',
  components: { Dropdown, ConfirmModal },
  props: {
    mileageCategory: {
      type: Object
    }
  },
  data () {
    return {
      showConfirmModal: false
    }
  },
  computed: {
    categoryName () {
      return this.mileageCategory.name
    },
    categoryRate () {
      const formattedRate = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximunFractionDigits: 3, minimumFractionDigits: 3, currencyDisplay: 'symbol' }).format(this.mileageCategory.rate)
      return formattedRate
    }
  },
  methods: {
    editMileageCategory () {
      this.$emit('editMileageCategory', this.mileageCategory.id)
    },
    handleDeleteMileageCategory () {
      this.showConfirmModal = true
    },
    async deleteMileageCategory () {
      this.$emit('removeMileageCategory', this.mileageCategory.id)
    }
  }
}
</script>
